import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useServiceRequest } from '../../../components/ServiceStatusProvider';

const ServiceOverview = () => {
  const navigate = useNavigate();
  const { requestCleaning } = useServiceRequest();

  const services = [
    {
      id: 2,
      name: "스탠다드 케어",
      price: "6,000원",
      // originalPrice: "5,000원",
      features: [
        "외부 전체 손세탁 클리닝",
        "내부(라이닝) 클리닝 포함",
        "인솔(깔창) 분리 세탁",
        "끈 분리 세탁",
        "일상 오염 제거 및 컨디션 정리",
        "무료 픽업·반납"
      ],
      icon: "Sparkles",
      popular: true
    }
  ];

  const isSingleService = services?.length === 1;

  const benefits = [
    {
      icon: "MessageCircle",
      title: "카카오톡 알림",
      description: "진행 상황을 실시간으로 알려드립니다"
    },
    {
      icon: "Hand",
      title: "손세탁 전문",
      description: "전용 솔과 용제를 사용해 신발을 안전하게 직접 손세탁합니다"
    },
    {
      icon: "Clock",
      title: "문 앞 수거·배송",
      description: "오전 9시 수거, 오후 8시 배송. 문 앞에 놓기만 하면 됩니다."
    },
    {
      icon: "ShieldCheck",
      title: "정직한 작업",
      description: "꼭 필요한 추가 케어는 사전 안내 후 진행합니다."
    }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-card rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl p-6 sm:p-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-3">
            서비스 안내
          </h2>
          <p className="text-muted-foreground">
기본 케어를 한 가지 기준으로 제공합니다          </p>
        </div>
        
        <div className="grid gap-6 md:grid-cols-2 mb-8">
          {services?.map((service) => (
            <div 
              key={service?.id}
              className={`relative border-2 rounded-lg p-6 transition-all duration-200 hover:shadow-lg ${
                service?.popular 
                  ? 'border-primary bg-primary/5' :'border-border bg-background'
              } ${isSingleService ? 'md:col-span-2 md:max-w-xl md:justify-self-center' : ''}`}
            >
              {/* {service?.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                  <span className="bg-primary text-primary-foreground px-4 py-1 rounded-full text-xs font-semibold">
                    이벤트 진행중
                  </span>
                </div>
              )} */}
              
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className={`p-3 rounded-lg ${
                    service?.popular ? 'bg-primary/20' : 'bg-muted'
                  }`}>
                    <Icon 
                      name={service?.icon} 
                      size={24} 
                      color={service?.popular ? 'var(--color-primary)' : 'var(--color-foreground)'}
                    />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-foreground">
                      {service?.name}
                    </h3>
                  </div>
                </div>
              </div>
              
              <div className="mb-6">
                <div className="flex items-baseline gap-2">
                  <span className="text-3xl font-bold text-foreground">
                    {service?.price}
                  </span>
                  {service?.originalPrice && (
                    <span className="text-lg text-muted-foreground line-through">
                      {service?.originalPrice}
                    </span>
                  )}
                </div>
                <p className="text-sm text-muted-foreground mt-1">
                  1켤레 기준
                </p>
              </div>
              
              <ul className="space-y-3 mb-6">
                {service?.features?.map((feature, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <Icon 
                      name="Check" 
                      size={20} 
                      color="var(--color-success)" 
                      className="flex-shrink-0 mt-0.5"
                    />
                    <span className="text-sm text-foreground">{feature}</span>
                  </li>
                ))}
              </ul>
              
              <Button 
                variant={service?.popular ? "default" : "outline"}
                fullWidth
                onClick={() => requestCleaning()}
                className={service?.popular 
                  ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700 shadow-lg hover:shadow-xl focus:ring-2 focus:ring-blue-300"
                  : "bg-white text-black border border-white hover:bg-white hover:text-black"}
              >
                신청하기
              </Button>
            </div>
          ))}
        </div>

        <div className="mx-auto max-w-[520px] text-left text-sm text-muted-foreground leading-relaxed">
          <p>✓ 스웨이드 케어(+₩3,000): 소재 특성상 별도 케어가 추가됩니다.</p>
          <p className="mt-2">✓ 틴트·황변 제거 등은 필요 시 안내드리며, 원하실 경우 선택 후 진행 가능합니다.</p>
        </div>

        <div className="mt-4 text-center">
          <Button 
            variant="ghost" 
            iconName="Info"
            iconPosition="left"
            onClick={() => navigate('/price-guide')}
          >
            자세한 이용 안내 보기
          </Button>
        </div>
      </div>
      <div className="bg-card rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl p-6 sm:p-8">
        <h3 className="text-2xl font-bold text-foreground mb-6 text-center">
          Sneaker Care의 특별함
        </h3>
        
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {benefits?.map((benefit, index) => (
            <div key={index} className="text-center space-y-3">
              <div className="inline-flex items-center justify-center bg-primary/10 p-4 rounded-full">
                <Icon name={benefit?.icon} size={28} color="var(--color-primary)" />
              </div>
              <h4 className="font-semibold text-foreground">
                {benefit?.title}
              </h4>
              <p className="text-sm text-muted-foreground">
                {benefit?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceOverview;